<template>
  <v-card outlined rounded="lg">
    <v-card-title class="font-weight-bold subtitle-1"
      >Títulos em aberto</v-card-title
    >
    <v-card-text>
      <v-row>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-list-item class="grey lighten-3 rounded-lg">
            <v-list-item-content>
              <v-list-item-subtitle>Valor a vencer</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold mt-1">{{
                formatarMoeda(perfil.posicaoatual.vlrtitavencer)
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <zoom-titulos
                title="Títulos a vencer"
                :subtitle="perfil.nome"
                :titulos="perfil.posicaoatual.zoom_avencer"
                v-if="perfil.posicaoatual.qtdtitavencer > 0"
              />
            </v-list-item-action>
          </v-list-item>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-list-item class="grey lighten-3 rounded-lg">
            <v-list-item-content>
              <v-list-item-subtitle>Valor em atraso</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold mt-1">{{
                formatarMoeda(perfil.posicaoatual.vlrtitatraso)
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <zoom-titulos
                title="Títulos atrasados"
                :subtitle="perfil.nome"
                :titulos="perfil.posicaoatual.zoom_atrasados"
                v-if="perfil.posicaoatual.qtdtitatraso > 0"
              />
            </v-list-item-action>
          </v-list-item>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-list-item class="grey lighten-3 rounded-lg">
            <v-list-item-content>
              <v-list-item-subtitle>Saldo devedor</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold mt-1">{{
                formatarMoeda(perfil.posicaoatual.saldodevedor)
              }}</v-list-item-title>
            </v-list-item-content>            
          </v-list-item>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatMoeda } from "@/global";
import ZoomTitulos from "./ZoomTitulos.vue";

export default {
  components: { ZoomTitulos },
  props: {
    perfil: Object,
  },
  methods: {
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
};
</script>

<style>
</style>